/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConversationStartedWebhookPayload } from '../../models/conversation-started-webhook-payload';

export interface PostConversationStartedWebhookSchema$Params {
}

export function postConversationStartedWebhookSchema(http: HttpClient, rootUrl: string, params?: PostConversationStartedWebhookSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<ConversationStartedWebhookPayload>> {
  const rb = new RequestBuilder(rootUrl, postConversationStartedWebhookSchema.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConversationStartedWebhookPayload>;
    })
  );
}

postConversationStartedWebhookSchema.PATH = '/api/webhooks/notifications/events/ConversationStarted';
